import { render, staticRenderFns } from "./AboutLecture.vue?vue&type=template&id=41791a53&scoped=true&"
import script from "./AboutLecture.vue?vue&type=script&lang=js&"
export * from "./AboutLecture.vue?vue&type=script&lang=js&"
import style0 from "./AboutLecture.vue?vue&type=style&index=0&id=41791a53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41791a53",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCard,VContainer,VDivider,VForm,VIcon,VSelect})
